// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"18e418ac","453":"ce3cd72b","461":"9e44c2cd","942":"c3d39d20"}[chunkId] + ".chunk.js";
};